import { gsap } from '../rk-gsap-core'

const navbarAnimations = () => {
  const navbar = document.querySelector('.navbar-outer')
  const navbarMenu = navbar?.querySelector('.navbar-container')
  const navbarLogo = navbar?.querySelector('.navbar-logo-container a')
  const navbarToggler = navbar?.querySelector('.navbar-toggler-outer')
  
  if (!navbar) return
  
  const tl = gsap.timeline()

  if (navbarLogo) {
    tl.to(navbarLogo, {
      opacity: 1,
      duration: 1.25,
      ease: 'power2.out'
    }, 0.2)
  }

  if (navbarMenu) {
    tl.to(navbarMenu, {
      opacity: 1,
      duration: 1.25,
      ease: 'power2.out'
    }, 0.75)
  }

  if (navbarToggler) {
    tl.to(navbarToggler, {
      opacity: 1,
      duration: 1.5,
      ease: 'power2.out'
    }, 0.75)
  }
}

// Parallax Backgrounds
const initializeParallaxBackgrounds = () => {
  const parallaxElements = document.querySelectorAll('.bg-parallax')
  const heroParallaxElements = document.querySelectorAll('.hero-bg-parallax')
  const heroBgParallaxImageElements = document.querySelectorAll('.hero-bg-parallax-image')

  parallaxElements.forEach(el => {
    gsap.to(el, {
      backgroundPositionY: '+=100px',
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
       }
    })
  })

  heroParallaxElements.forEach(el => {
    gsap.fromTo(el, {
      backgroundPositionY: '0px'
    }, {
      backgroundPositionY: '+=150px',
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        // markers: true
       }
    })
  })

  heroBgParallaxImageElements.forEach(el => {
    const image = el.querySelector('img')

    if (!image) return

    gsap.fromTo(image, {
      y: 0
    }, {
      y: 150,
      ease: 'none',
      scrollTrigger: {
        trigger: image,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        // markers: true
       }
    })
  })
}

const initializeHeroFadeIn = () => {
  const heroFadeInElements = document.querySelectorAll('.hero-fade-in')
  console.log('Initializing hero fade-in for elements:', heroFadeInElements)
  
  heroFadeInElements.forEach(el => {
    gsap.to(el, {
      opacity: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: 1.5
    })
  })
}

const initializeFadeInOnScroll = () => {
  const fadeInElements = document.querySelectorAll('.fade-in-on-scroll')

  fadeInElements.forEach(el => {
    gsap.fromTo(el, {
      opacity: 0
    }, {
      opacity: 1,
      y: 0,
      duration: 1.5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 60%',
        end: 'bottom top',
        toggleActions: 'play none none reverse',
        // markers: true
       }
    })
  })
}

const initializeImageFadeIn = () => {
  const imageFadeInElements = document.querySelectorAll('.image-fade-in')

  imageFadeInElements.forEach(el => {
    gsap.fromTo(el, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 67%',
        toggleActions: 'play none none none'
      }
    })
  })
}

const initializeStaggerFadeIn = () => {
  const staggerFadeInElements = document.querySelectorAll('.stagger-fade-in')

  staggerFadeInElements.forEach(container => {
    const children = Array.from(container.children)

    if (children.length === 0) {
      return
    }

    gsap.fromTo(children, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 0.9,
      ease: 'power2.out',
      stagger: 0.18,
      scrollTrigger: {
        trigger: container,
        start: 'top 67%',
        toggleActions: 'play none none none'
      }
    })
  })
}

// Global Animations
export default function initializeGlobalAnimations() {
  navbarAnimations()
  initializeParallaxBackgrounds()
  initializeHeroFadeIn()
  initializeFadeInOnScroll()
  initializeImageFadeIn()
  initializeStaggerFadeIn()
}